<template>
  <div id="app">
    <spoof-badge/>
    <layout-broker/>
    <div>
      <portal-target name="MODAL" multiple />
    </div>
  </div>
</template>

<script>
import LayoutBroker from '@/layouts/LayoutBroker';
import SpoofBadge from '@/components/SpoofBadge';

const title = 'Quality Pros For A Better Home';
const description = 'Pro Referral, powered by The Home Depot (formerly Redbeacon) helps connect homeowners with quality home improvement professionals in their neighborhood.';
export default {
  name: 'app',
  metaInfo: {
    title,
    titleTemplate: '%s | Pro Referral',
    meta: [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
    ],
  },
  components: {
    LayoutBroker,
    SpoofBadge,
  },
};
</script>

<style lang="scss">
  @import "~@homeservices/design-kit/design-kit.scss";
  @import "~@/styles/datepicker.scss";
  @import "~@/styles/keyframes.scss";
  @import "~@/styles/tooltips.scss";
  @import "~@/styles/transitions.scss";
  @import "~@/styles/header.scss";
  @import "~@/styles/link.scss";

  @import url('https://fonts.googleapis.com/css?family=Open+Sans:600&display=swap');

  @font-face {
    font-family: helvetica-neue;
    src: url(/fonts/helvetica/HelveticaNeueLTW01-55Roman.eot);
    src: url(/fonts/helvetica/HelveticaNeueLTW01-55Roman.eot#iefix)
        format("embedded-opentype"),
      url(/fonts/helvetica/HelveticaNeueLTW01-55Roman.woff2) format("woff2"),
      url(/fonts/helvetica/HelveticaNeueLTW01-55Roman.woff) format("woff"),
      url(/fonts/helvetica/HelveticaNeueLTW01-55Roman.ttf) format("truetype");
    font-weight: 400;
    font-style: normal
  }

  @font-face {
    font-family: helvetica-neue;
    src: url(/fonts/helvetica/HelveticaNeueLTW01-65Medium.eot);
    src: url(/fonts/helvetica/HelveticaNeueLTW01-65Medium.eot#iefix)
        format("embedded-opentype"),
      url(/fonts/helvetica/HelveticaNeueLTW01-65Medium.woff2) format("woff2"),
      url(/fonts/helvetica/HelveticaNeueLTW01-65Medium.woff) format("woff"),
      url(/fonts/helvetica/HelveticaNeueLTW01-65Medium.ttf) format("truetype");
    font-weight: 600;
    font-style: normal
  }

  @font-face {
    font-family: helvetica-neue;
    src: url(/fonts/helvetica/HelveticaNeueLTW01-75Bold.eot);
    src: url(/fonts/helvetica/HelveticaNeueLTW01-75Bold.eot#iefix)
        format("embedded-opentype"),
      url(/fonts/helvetica/HelveticaNeueLTW01-75Bold.woff2) format("woff2"),
      url(/fonts/helvetica/HelveticaNeueLTW01-75Bold.woff) format("woff"),
      url(/fonts/helvetica/HelveticaNeueLTW01-75Bold.ttf) format("truetype");
    font-weight: 700;
    font-style: normal
  }

  .text-semibold {
    font-weight: 600;
  }

  // TODO: (Adam/Volkan) this needs to be in vk
  .vk-modal-open {
    overflow: hidden;
    position: fixed;
    width: 100%;
  }

  html, body, #app {
    height: 100%;
    font-family: helvetica-neue, sans-serif !important;
  }

  p {
    margin: 0;
  }

  .x-orange-emphasis em {
    font-style: normal;
    color: $color-depot;
    font-weight: bold;
  }

  .x-container-max {
    @include responsive('max-width', 100%, $tablet, $desktop, $wide);
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .x-background-color-transparent {
    background-color: transparent;
  }

  .x-main-route {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1 1 auto;

    & > * {
      // We only want these containers scrolling on mobile - for smooth scrolling on iOS
      @include mobile-only() {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
    }
  }

  // TODO - add to design-kit
  // word-wrap: break-word; not working on elements that do not have an explicit width
  .x-min-width-0 {
    min-width: 0!important;
  }

  // TODO - add to design-kit
  .x-word-wrap-break-word {
    word-wrap: break-word;
  }

  .x-white-space-pre-wrap {
    white-space: pre-wrap;
  }

  // TODO - add to design-kit
  .x-line-height-normal {
    line-height: normal !important;
  }

  .x-reset-list-styles {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  // Maybe add dk?
  .x-standard-shadow {
    box-shadow: 0 2px 4px 0 $color-gray30;
  }

  svg {
    box-sizing: content-box;
  }

  @media print {
    .x-print-hide {
      display: none !important;
    }
  }

  .x-terms-of-service {
    @include text-medium();

    p {
      @include margin-bottom(1.6);
    }

    ol, ul {
      @include padding(0);
      @include margin(0 0 1.6 0);
      list-style-type: none;
    }

    li {
      @include padding(1.6);
    }
  }

  .new-label-badge {
    &:after {
      @include text-small;
      content: 'NEW';
      margin-left: 2*$unit;
      padding: $unit/4 $unit;
      font-weight: 600;
      color: white;
      background-color: $color-yellow;
      border-radius: 3px;
    }
  }
</style>
